/**
 * CommonUtils
 */

import { numberUtils } from '@ustra/core'

export function test() {}

/**
 * 주문번호형식 ex: 20200603-997440-1
 * @param ordNo 주문번호
 * @param ordSeq 상세순번
 */
export function orderNoFormat(ordNo: string, ordSeq: string) {
  if (ordNo != null && ordNo.length >= 14) return ordNo.substr(0, 8) + '-' + ordNo.substr(8, 6) + '-' + ordSeq

  return ordNo + '-' + ordSeq
}

/**
 * 날짜 형식 20200101 -> 2020-01-01
 * @param datestr
 */
export function dateFormat(datestr: string) {
  if (!datestr) return ''
  const newStr = datestr.replace('-', '').replace('-', '')
  return `${newStr.substr(0, 4)}-${newStr.substr(4, 2)}-${newStr.substr(6, 2)}`
}

export function keyUpNotDot(e: KeyboardEvent) {
  if (e.code === 'Period') e.preventDefault()
}

/**
 * number empty to zero
 * @param num
 */
export function emptyToZero(num: string | number) {
  if (num!) if (!num) return 0
  return numberUtils.formatCurrency(num)
}

/**
 * 화면에 날짜 30 이내 체크
 * @param fromDate 시작일
 * @param toDate 마감일
 * @param maxDay
 */
export function checkCommonDate(fromDate, toDate, maxDay: number = 31) {
  if (fromDate === '' || toDate === '') {
    alert('기간을 설정해 주세요.')
    return false
  }

  console.log('==========from, to , max=============', fromDate, toDate, maxDay)
  const interval = dateIntervalDay(fromDate, toDate)
  console.log('interval=======================', interval + 1)
  if (interval + 1 > maxDay) {
    alert(`최대 날짜 조회기간은 ${maxDay}일 입니다.`)
    return false
    alert('날짜 선택이 잘못되었습니다.')
  } else if (interval <= -1) {
    return false
  }

  return true
}

export function dateIntervalDay(startDate, endDate): number {
  // startDate = startDate.replace('-', '').replace('-', '')
  // endDate = endDate.replace('-', '').replace('-', '')
  // const date1: any = new Date(startDate.substr(0, 4), startDate.substr(4, 2), startDate.substr(6, 2))
  // const date2: any = new Date(endDate.substr(0, 4), endDate.substr(4, 2), endDate.substr(6, 2))
  // const interval = date2 - date1
  // const day = 1000 * 60 * 60 * 24
  // return interval / day
  const sdt = new Date(startDate)
  const edt = new Date(endDate)
  const dateDiff = Math.ceil((edt.getTime() - sdt.getTime()) / (1000 * 3600 * 24))
  return dateDiff
}

/**
 * 휴대전화번호 자동 하이픈
 * @param str 휴대전화번호
 */
export function autoHypenHP(str: string): string {
  str = str.replace(/[^0-9]/g, '')
  let tmp = ''
  if (str.length < 4) {
    return str
  } else if (str.length < 7) {
    tmp += str.substr(0, 3)
    tmp += '-'
    tmp += str.substr(3)
    return tmp
  } else if (str.length < 11) {
    tmp += str.substr(0, 3)
    tmp += '-'
    tmp += str.substr(3, 3)
    tmp += '-'
    tmp += str.substr(6)
    return tmp
  } else {
    tmp += str.substr(0, 3)
    tmp += '-'
    tmp += str.substr(3, 4)
    tmp += '-'
    tmp += str.substr(7)
    return tmp
  }
}

export function autoHypenTel(str: string, preLen: number): string {
  str = str.replace(/[^0-9]/g, '')
  console.log(str, preLen)
  let tmp = ''
  if (preLen === 3) {
    if (str.length <= 4) {
      return str
    } else if (str.length <= 8) {
      tmp += str.substr(0, 4)
      tmp += '-'
      tmp += str.substr(4)
      console.log('tmp22,', tmp)
      return tmp
    } else {
      tmp += str.substr(0, 4)
      tmp += '-'
      tmp += str.substr(4, 4)
      return tmp
    }
  } else if (preLen === 2) {
    if (str.length < 3) {
      return str
    } else if (str.length < 7) {
      tmp += str.substr(0, 3)
      tmp += '-'
      tmp += str.substr(3)
      return tmp
    } else {
      tmp += str.substr(0, 3)
      tmp += '-'
      tmp += str.substr(3, 4)
      return tmp
    }
  }
}

/**
 * 이메일 유효성 검사
 * @param {string} email 이메일
 */
export function emailValid(email: string): boolean {
  const pattern = /^(([^<>[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return pattern.test(email)
}

/**
 * 파일 다운로드
 * @param arraybuffer
 * @param filename
 */
export function fileDownload(arraybuffer: any, filename: string, isNative: boolean = false) {
  const blob = new Blob([arraybuffer as Blob])
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename)
  } else if (isNative) {
    const blob2 = new Blob([arraybuffer as Blob], { type: 'application/pdf' })
    const url = window.URL.createObjectURL(blob2)
    const a = document.createElement('a')
    a.href = url
    a.target = '_self'
    document.body.appendChild(a)
    a.download = filename
    a.click()
    document.removeChild(a)
  } else {
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.target = '_self'
    document.body.appendChild(a)
    a.download = decodeURI(filename)
    a.click()
    document.removeChild(a)
  }
}

/**
 * ASCII값으로 치환
 * @param {string} txt
 * @param {number} i
 */
export function ufnASCII(txt: string, i: number) {
  return txt.substr(i, i + 1).charCodeAt(0)
}

/**
 * 비밀번호 유효성 검사
 * @param {string} txt 비밀번호 문자열
 * @return {boolean | string} true | 메세지
 */
export function passWordCheck(txt: string): boolean | string {
  let vNum = 0
  let vEngL = 0
  let vEngS = 0
  let vSpe = 0

  // 1.비밀번호포함된 문자,숫자,특수문자구분,한글
  for (let i = 0; i < txt.length; i++) {
    if (ufnASCII(txt, i) >= 48 && ufnASCII(txt, i) <= 57) {
      vNum = 1
    } // 숫자
    else if (ufnASCII(txt, i) >= 65 && ufnASCII(txt, i) <= 90) {
      vEngL = 1
    } // 영대
    else if (ufnASCII(txt, i) >= 97 && ufnASCII(txt, i) <= 122) {
      vEngS = 1
    } // 영소
    else if (
      (ufnASCII(txt, i) >= 33 && ufnASCII(txt, i) <= 47) ||
      (ufnASCII(txt, i) >= 58 && ufnASCII(txt, i) <= 64) ||
      (ufnASCII(txt, i) >= 91 && ufnASCII(txt, i) <= 96) ||
      (ufnASCII(txt, i) >= 123 && ufnASCII(txt, i) <= 126)
    ) {
      vSpe = 1 // 특수문자
    }
  }

  // 2.비밀번호 자리수 체크 및 자리수별 조합된 경우의 수 체크
  if (txt.length < 8) {
    return '비밀번호 최소 8자리 이상 사용가능합니다.'
  } else if (txt.length >= 8 && txt.length <= 9 && vNum + vEngL + vEngS + vSpe <= 2) {
    return '비밀번호 8자리 이상 10자리 미만인 경우, 영소문자, 영대문자, 숫자, 특수문자의 조합이 3가지 이상으로 구성해야합니다.'
  } else if (txt.length >= 10 && vNum + vEngL + vEngS + vSpe < 2) {
    return '비밀번호 10자리 이상인 경우, 영소문자, 영대문자, 숫자, 특수문자의 조합이 2가지 이상으로 구성해야합니다.'
  }

  // 3.연속된숫자 및 문자 체크 / 연속 중복된 문자,숫자 체크
  for (let i = 0; i < txt.length; i++) {
    if (
      (ufnASCII(txt, i) - ufnASCII(txt, i - 1) === 1 && ufnASCII(txt, i - 1) - ufnASCII(txt, i - 2) === 1) ||
      (ufnASCII(txt, i) - ufnASCII(txt, i - 1) === -1 && ufnASCII(txt, i - 1) - ufnASCII(txt, i - 2) === -1)
    ) {
      if (ufnASCII(txt, i - 1) >= 40 && ufnASCII(txt, i - 1) <= 57) {
        return '연속된 숫자는 비밀번호로 사용하실수 없습니다.'
      } else if (ufnASCII(txt, i - 1) >= 65 && ufnASCII(txt, i - 1) <= 90) {
        return '연속된 영대문자는 비밀번호로 사용하실수 없습니다.'
      } else if (ufnASCII(txt, i - 1) >= 97 && ufnASCII(txt, i - 1) <= 122) {
        return '연속된 영소문자는 비밀번호로 사용하실수 없습니다.'
      }
    } else if (ufnASCII(txt, i) - ufnASCII(txt, i) === 0 && ufnASCII(txt, i - 1) - ufnASCII(txt, i - 2) === 0) {
      return '동일한 문자,숫자는 연속해서 비밀번호로 사용하실수 없습니다.'
    }
  }
  return true
}

/* djyoo 21.07.20
 ** 10,000,000 형식을 포함한 숫자형 문자열을 Number type으로 반환
 */
export function parseNumber(value: string | number) {
  if (typeof value === 'number') return value

  if (!value) return 0

  try {
    value = value.replace(/,/gi, '')
    return Number(value)
  } catch {
    return 0
  }
}
